import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForThreeAgentsText,
    Headings,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../components";

export const ExistingUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <SignupBackgroundLayout
            ProductLogo={<ServiceCollectionLogo />}
            theme="yellow"
        >
            {team26VisualUpdates ? (
                <Headings
                    main={<WelcomeBackText />}
                    sub={<FreeForThreeAgentsText />}
                />
            ) : (
                <>
                    <WelcomeBackHeading />
                    <SubHeading>
                        <FreeForThreeAgentsText />
                    </SubHeading>
                </>
            )}
            <SiteActivation />
        </SignupBackgroundLayout>
    );
};
